import propertyAPI from '@/api/properties'
// import { HttpFunctions } from '@/api/http-functions'

export const getCurrencyAPI = ({ commit }) => {
  return new Promise((resolve) => {
    propertyAPI.getCurrency(result => {
      commit('setCurrency', result.data.data.currency)
      resolve()
    })
  })
}



// WEBPACK FOOTER //
// ./src/store/modules/properties/actions.js